import { tv } from "tailwind-variants"

/**
 * Set of common border UI patterns for interactive and transparent variants
 */
export const borderVariants = tv({
  base: "border",
  variants: {
    border: {
      "border-1": "",
      "border-2": "",
      "border-3": "",
      frosted: "border-frosted-2",
      rare: "border-rare",
    },
    interactive: {
      true: "",
      false: "",
    },
    transparent: {
      true: "",
      false: "",
    },
  },
  compoundVariants: [
    // Border-1
    {
      border: "border-1",
      transparent: false,
      className: "border-border-1",
    },
    {
      border: "border-1",
      transparent: true,
      className: "border-border-1-transparent",
    },
    {
      border: "border-1",
      interactive: true,
      transparent: false,
      className:
        "hover:border-border-2 focus:border-border-2 active:border-border-2",
    },
    {
      border: "border-1",
      interactive: true,
      transparent: true,
      className:
        "hover:border-border-2-transparent focus:border-border-2-transparent active:border-border-2-transparent",
    },
    // Border-2
    {
      border: "border-2",
      transparent: false,
      className: "border-border-2",
    },
    {
      border: "border-2",
      transparent: true,
      className: "border-border-2-transparent",
    },
    {
      border: "border-2",
      interactive: true,
      transparent: false,
      className:
        "hover:border-border-3 focus:border-border-3 active:border-border-3",
    },
    {
      border: "border-2",
      interactive: true,
      transparent: true,
      className:
        "hover:border-border-3-transparent focus:border-border-3-transparent active:border-border-3-transparent",
    },
    // Border-3
    {
      border: "border-3",
      transparent: false,
      className: "border-border-3",
    },
    {
      border: "border-3",
      transparent: true,
      className: "border-border-3-transparent",
    },
  ],
  defaultVariants: {
    interactive: false,
    transparent: false,
  },
})
